export default __webpack_public_path__ + "static/media/changing-pickle.4685c003.gif";